import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {combineReducers, configureStore} from '@reduxjs/toolkit'
import notifreducers from './_metronic/redux/content'
import orderReducer from './redux/slices/orderSlices'
import sipReducer from './redux/slices/sipSlices'
import financialDocsReducer from './redux/slices/financialDocsSlices'
import soReducer from './redux/slices/soSlices'
import contractReducer from './redux/slices/contractSlices'
import customerReducer from './redux/slices/customerSlices'
import priceReducer from './redux/slices/priceSlices'
import endUserReducer from './redux/slices/endUserSlices'
import invoiceReducer from './redux/slices/invoiceSlices'
import amandmentReducer from './redux/slices/amandementSlices'
import filterReducer from './redux/slices/filterSlices'
import {masterdataApi} from './services/masterdataApi'
import authReducer from './redux/slices/authSlices'
import appReducer from './redux/slices/appSlices'
import notificationReducer from './redux/slices/notificationSlices'
import type {PreloadedState} from '@reduxjs/toolkit'

const authPersistedReducer = persistReducer({key: 'auth', storage}, authReducer)
const appPersistedReducer = persistReducer({key: 'app', storage}, appReducer)

const rootReducer = combineReducers({
  [masterdataApi.reducerPath]: masterdataApi.reducer,
  authPersistedReducer,
  appPersistedReducer,
  notif: notifreducers,
  orderReducer,
  sipReducer,
  soReducer,
  contractReducer,
  financialDocsReducer,
  customerReducer,
  priceReducer,
  endUserReducer,
  invoiceReducer,
  amandmentReducer,
  filterReducer,
  notificationReducer,
})

export const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
        ignoredActionPaths: ['persist/PERSIST'],
        ignoredPaths: ['persist/PERSIST'],
      },
    }).concat(masterdataApi.middleware),
  reducer: rootReducer,
})

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(masterdataApi.middleware),
    reducer: rootReducer,
    preloadedState,
  })
}

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>

export const persistor = persistStore(store)
